"use strict";

exports.__esModule = true;
exports.BLOG_HEADER_CURSOR = exports.BLOG_HEADER_TOTAL_RESULTS = void 0;
var BLOG_HEADER_TOTAL_RESULTS = 'Wix-SocialBlog-TotalResults';
exports.BLOG_HEADER_TOTAL_RESULTS = BLOG_HEADER_TOTAL_RESULTS;
var BLOG_HEADER_CURSOR = 'wix-socialblog-cursor';
exports.BLOG_HEADER_CURSOR = BLOG_HEADER_CURSOR;